export class EnderecoLocalTipo {
    Id: string; // No modelo o campo é "IDEnderecoLocalTipo", utilizando "Id" por limitação do Mock-up
    DescricaoEnderecoLocalTipo: string;
}



// WEBPACK FOOTER //
// ./src/app/endereco-local-tipo/endereco-local-tipo.model.ts